import React, { useEffect, useState, useRef, useMemo } from "react";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Table,
  Badge
} from "reactstrap";
import { ExportToExcel } from '../../../ExportToExcel';

import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";

import {
  getAuthority as onGetReports, // Action ismini mantıksal olarak güncelledik (Backend'den Raporları çeker)
} from "store/contacts/actions";

//redux
import { useSelector, useDispatch } from "react-redux";

const ContactsList = props => {

  document.title = "Sınav Raporları | DLApro ADMIN PANELI";

  const dispatch = useDispatch();
  
  // Detay Modalı için State'ler
  const [modalResults, setModalResults] = useState(false);
  const [selectedUserReports, setSelectedUserReports] = useState([]);
  const [selectedUserName, setSelectedUserName] = useState("");

  // Redux'tan Users_Question_Report listesini çekiyoruz
  const { reportList } = useSelector(state => ({
    reportList: state.contacts.authlist, // State yapınıza göre burası değişebilir
  }));

  // --- VERİ GRUPLAMA MANTIĞI ---
  // Gelen rapor satırlarını (Users_Question_Report) KULLANICIYA göre grupluyoruz.
  const groupedData = useMemo(() => {
    if (!reportList) return [];
    
    const groups = {};
    
    reportList.forEach(report => {
      // Users tablosu ile joinli gelmesi beklenir
      const userId = report.Users_ID;
      const userObj = report.Users || {}; // Backend'den joinli gelen Users objesi

      if (!userId) return; // Kullanıcısı olmayan raporu atla (veya mantığa göre işle)

      const key = `user_${userId}`;
      
      if (!groups[key]) {
        groups[key] = {
          Users: userObj, 
          Users_ID: userId,
          TotalReports: 0,
          LastTestDate: report.Created_DateTime,
          AllReports: [] // O kullanıcının tüm raporlarını burada topluyoruz
        };
      }
      
      groups[key].TotalReports += 1;
      groups[key].AllReports.push(report);
      
      // En son sınav tarihini güncelle
      if (new Date(report.Created_DateTime) > new Date(groups[key].LastTestDate)) {
        groups[key].LastTestDate = report.Created_DateTime;
      }
    });

    return Object.values(groups);
  }, [reportList]);


  // PDF Export (Detaylı liste dökümü)
  const exportPDF = () => {
    const unit = "pt";
    const size = "A4";
    const orientation = "portrait";
    const doc = new jsPDF(orientation, unit, size);

    const title = "DLA Sınav Sonuçları Listesi";
    doc.text(title, 40, 40);

    const headers = [["Kullanıcı", "Tarih", "Rapor No", "Tür", "Skor"]];

    // Düz liste üzerinden export alıyoruz (reportList direkt kullanılır)
    const data = (reportList || []).map(item => {
      const userInfo = item.Users ? (item.Users.Users_NameSurname || item.Users.EMail) : "-";
      return [
        userInfo,
        moment(item.Created_DateTime).format('DD.MM.YYYY HH:mm'),
        item.Report_Number || "-",
        item.Report_Type || "Standart",
        item.Score ? item.Score.toFixed(1) : "0"
      ];
    });

    let content = {
      startY: 50,
      head: headers,
      body: data,
      styles: { font: 'helvetica', fontSize: 8 }
    };

    doc.autoTable(content);
    doc.save("dla-sinav-raporlari.pdf");
  }

  // --- ANA TABLO SÜTUNLARI (Kullanıcı Listesi) ---
  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => <input type="checkbox" className="form-check-input" />,
      },
      {
        Header: "Kullanıcı Bilgisi",
        accessor: "Users", 
        filterable: true,
        Cell: cellProps => {
          const user = cellProps.row.original.Users;
          if (user) {
            return (
              <div>
                <h5 className="font-size-14 mb-1">{user.Users_NameSurname || "İsimsiz Kullanıcı"}</h5>
                <p className="text-muted mb-0 font-size-12">{user.EMail || user.PhoneNumber}</p>
              </div>
            );
          }
          return "-";
        },
      },
      {
        Header: "Son Sınav Tarihi",
        accessor: "LastTestDate",
        Cell: cellProps => {
            return <>{moment(cellProps.value).format('DD.MM.YYYY HH:mm')}</>
        }
      },
      {
        Header: "Toplam Sınav",
        accessor: "TotalReports",
        Cell: cellProps => {
            return <Badge color="primary" className="font-size-12">{cellProps.value} Adet</Badge>
        }
      },
      {
        Header: "İşlemler",
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">
              <Button
                color="info"
                size="sm"
                className="btn-rounded"
                onClick={() => {
                  handleShowResults(cellProps.row.original);
                }}
              >
                <i className="mdi mdi-file-document-outline me-1" />
                Raporları Gör
              </Button>
            </div>
          );
        },
      },
    ],
    []
  );

  useEffect(() => {
    // Sayfa yüklendiğinde raporları çek
    if (!reportList || !reportList.length) {
      dispatch(onGetReports());
    }
  }, [dispatch, reportList]);


  // "Raporları Gör" butonuna basınca çalışır
  const handleShowResults = (groupedRow) => {
    // Seçilen kullanıcının raporlarını tarihe göre sırala (Yeniden eskiye)
    const sortedReports = groupedRow.AllReports.sort((a,b) => new Date(b.Created_DateTime) - new Date(a.Created_DateTime));
    
    setSelectedUserReports(sortedReports);
    
    // Başlık için isim
    let name = "Kullanıcı";
    if(groupedRow.Users) {
        name = groupedRow.Users.Users_NameSurname || groupedRow.Users.EMail;
    }
    setSelectedUserName(name);
    
    setModalResults(true);
  };

  const toggleResults = () => {
    setModalResults(!modalResults);
  };

  // Delete işlemleri için dummy state (Gerekirse backend entegrasyonu yapılmalı)
  const [deleteModal, setDeleteModal] = useState(false);
  const handleDeleteUser = () => setDeleteModal(false);

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />

      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Sınav Performans Raporları" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="d-flex gap-2 mb-3">
                    <ExportToExcel apiData={reportList} fileName={"dla_sinav_sonuclari"} />
                    <button className="btn btn-danger" onClick={exportPDF}>
                      <i className="mdi mdi-file-pdf me-1"></i> PDF İndir
                    </button>
                  </div>

                  {/* ANA TABLO: KULLANICI BAZLI GRUPLANMIŞ LİSTE */}
                  <TableContainer
                    columns={columns}
                    data={groupedData}
                    isGlobalFilter={true}
                    isAddAuthList={false}
                    customPageSize={10}
                    className="custom-header-css"
                  />

                  {/* DETAY MODALI: KULLANICININ GEÇMİŞ SINAVLARI */}
                  <Modal isOpen={modalResults} toggle={toggleResults} size="xl" scrollable={true}>
                    <ModalHeader toggle={toggleResults}>
                        <i className="mdi mdi-account-circle me-2"></i>
                        <span className="text-primary fw-bold">{selectedUserName}</span> - Sınav Geçmişi
                    </ModalHeader>
                    <ModalBody>
                        <div className="table-responsive">
                            <Table className="table mb-0 align-middle table-hover table-striped">
                                <thead className="table-light">
                                    <tr>
                                        <th>Tarih / Rapor No</th>
                                        <th>Sınav Tipi</th>
                                        <th className="text-center">Akıcılık</th>
                                        <th className="text-center">Kelime</th>
                                        <th className="text-center">Gramer</th>
                                        <th className="text-center">Telaffuz</th>
                                        <th className="text-center">Görev</th>
                                        <th className="text-end">GENEL SKOR</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedUserReports.map((report, index) => {
                                        // Puanları güvenli şekilde al
                                        const fluency = report.Fluency_Score?.toFixed(1) || "-";
                                        const lexical = report.Lexical_Score?.toFixed(1) || "-";
                                        const grammar = report.Grammar_Score?.toFixed(1) || "-";
                                        const pronunciation = report.Pronunciation_Score?.toFixed(1) || "-";
                                        const taskComp = report.Task_Completion_Score?.toFixed(1) || "-";
                                        const totalScore = report.Score?.toFixed(1) || "0.0";

                                        return (
                                            <tr key={report.ID || index}>
                                                <td>
                                                    <div className="fw-bold">{moment(report.Created_DateTime).format('DD.MM.YYYY')}</div>
                                                    <div className="text-muted font-size-12">
                                                        {moment(report.Created_DateTime).format('HH:mm')}
                                                        <span className="ms-2 text-info">#{report.Report_Number}</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <Badge color="warning" className="font-size-12">
                                                        {report.Report_Type || "Genel"}
                                                    </Badge>
                                                </td>
                                                
                                                {/* Detay Puanları */}
                                                <td className="text-center">{fluency}</td>
                                                <td className="text-center">{lexical}</td>
                                                <td className="text-center">{grammar}</td>
                                                <td className="text-center">{pronunciation}</td>
                                                <td className="text-center">{taskComp}</td>

                                                {/* Genel Skor */}
                                                <td className="text-end">
                                                    <div className="d-flex justify-content-end align-items-center">
                                                        <span className="fs-5 fw-bold text-success">{totalScore}</span>
                                                        <span className="text-muted font-size-12 ms-1">/ 10</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                    
                                    {selectedUserReports.length === 0 && (
                                        <tr>
                                            <td colSpan="8" className="text-center py-4">
                                                <div className="text-muted">Bu kullanıcıya ait sınav kaydı bulunamadı.</div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </ModalBody>
                  </Modal>

                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);